// extracted by mini-css-extract-plugin
export default {"CurrencyInput":"styles_CurrencyInput__TQmjl"};